import { AccordionCivilUnion as CivilUnionVM } from 'shell/view-models/accordion-civil-union';
import { CivilUnion } from 'shell/models/person/civil-union';
import { transformCitizen } from '../citizenship-shared';
import { transformGenerality } from '../registry-office/generality';
import { transformDocumentDigital } from '../shared/transform-document-digital';
import { defaultChoicePickerState } from 'shell/components/shared/choice-date/constants';

export const transformCivilUnionAnpr05 = (
  values: CivilUnionVM | undefined
): CivilUnion | undefined => {
  const eventChoiceDate = values?.eventChoiceDate || defaultChoicePickerState;

  const unitoCivilmente = transformGenerality(values?.generality || null, values?.person || null);

  const cittadinanza = transformCitizen({
    citizenship: values?.citizenship?.value || '',
    code: values?.citizenship?.id || values?.citizenshipCode || '',
    note: values?.note,
    validityDate: values?.from?.toFormat('dd/MM/yyyy') || '',
  });

  const withActPaper =
    values?.paper?.actYear ||
    values?.paper?.actPart ||
    values?.paper?.actSeries ||
    values?.paper?.actNumber ||
    values?.paper?.actVolume ||
    values?.paper?.actDate ||
    values?.paper?.actMunicipality?.description ||
    values?.paper?.actMunicipality?.id ||
    values?.paper?.actMunicipality?.province;

  const withActDigital = Boolean(values?.digital);

  const returnData: CivilUnion | undefined = values
    ? {
        unitoCivilmente,
        cittadinanza,
        attoUnione: {
          dataEvento: values?.eventDate?.toFormat('yyyy-MM-dd') || undefined,
          senzaGiorno:
            !eventChoiceDate?.includes('day') && eventChoiceDate?.includes('month')
              ? '1'
              : undefined,
          senzaGiornoMese:
            !eventChoiceDate?.includes('day') && !eventChoiceDate?.includes('month')
              ? '1'
              : undefined,
          luogoEvento: {
            comune: !values?.isForeign
              ? {
                  nomeComune: values?.italian?.municipality?.description || undefined,
                  siglaProvinciaIstat: values?.italian?.municipality?.province || undefined,
                }
              : undefined,
            localita: values?.isForeign
              ? {
                  codiceStato: values?.foreign?.state?.id || undefined,
                  descrizioneStato: values?.foreign?.state?.value || undefined,
                  provinciaContea: values?.foreign?.province || undefined,
                  descrizioneLocalita: values?.foreign?.municipality?.description || undefined,
                }
              : undefined,
            luogoEccezionale:
              values?.isForeign && values?.foreign?.state?.id ? undefined : undefined,
          },

          attoEventoANPR:
            withActPaper || withActDigital
              ? {
                  atto: withActPaper
                    ? {
                        anno: values?.paper?.actYear || undefined,
                        parte: values?.paper?.actPart || undefined,
                        serie: values?.paper?.actSeries || undefined,
                        numeroAtto: values?.paper?.actNumber || undefined,
                        volume: values?.paper?.actVolume || undefined,
                        dataFormazioneAtto:
                          values?.paper?.actDate?.toFormat('yyyy-MM-dd') || undefined,
                        trascritto: values?.paper?.transcribed ? '1' : undefined,
                        comuneRegistrazione: values?.paper?.actMunicipality
                          ? {
                              nomeComune: values?.paper?.actMunicipality?.description || undefined,
                              codiceIstat: values?.paper?.actMunicipality?.id || undefined,
                              siglaProvinciaIstat:
                                values?.paper?.actMunicipality?.province || undefined,
                            }
                          : undefined,
                      }
                    : undefined,
                  attoANSC: withActDigital
                    ? transformDocumentDigital(values?.digital || undefined)
                    : undefined,
                }
              : undefined,
        },
        ordineUnione: values?.number?.toString() || undefined,
      }
    : undefined;

  return returnData;
};
